import React from 'react';
import { useTranslation } from 'react-i18next';

const ALERT_CLASS_BY_TYPE = {
  success: 'alert-success',
  error: 'alert-error',
  warning: 'alert-warning'
};

const Toast = ({ toast, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className={`alert toast ${ALERT_CLASS_BY_TYPE[toast.type]}`} role="alert">
      <span className="toast-message">{toast.message}</span>
      <button
        type="button"
        className="toast-close"
        aria-label={t('common.close')}
        onClick={() => onClose(toast.id)}
      >
        &times;
      </button>
    </div>
  );
};

export default Toast;
